export function user(state = null, action) {
  switch (action.type) {
    case 'LOGIN_REQUEST':
    case 'LOGOUT_DONE':
      return null;
    case 'LOGIN_DONE':
    case 'REFRESH_TOKEN_DONE':
      return action.user;
    default:
      return state;
  }
}
